import { useCallback, useEffect, useState } from 'react';
import { consentAPI } from '../services/api';

/**
 * Tracks the current user's monitoring-consent status and exposes a grant action.
 * status: 'loading' | 'granted' | 'needed' | 'error'
 * The server decides "granted" (a stored grant only counts if its version matches
 * the current consent copy), so re-consent on a version bump is automatic.
 */
export function useConsent(consentType = 'interaction_monitoring') {
  const [status, setStatus] = useState('loading');
  const [currentVersion, setCurrentVersion] = useState(null);
  // KAN-560 (Ricardo 14768): the journey age group from the birth year (A1 = 13-17), so the
  // consent screen can show the 13-17 wording. null when unknown.
  const [ageGroup, setAgeGroup] = useState(null);

  const refresh = useCallback(async () => {
    setStatus('loading');
    try {
      const { data } = await consentAPI.getStatus(consentType);
      setCurrentVersion(data.current_version);
      setAgeGroup(data.age_group || null);
      setStatus(data.granted ? 'granted' : 'needed');
    } catch (e) {
      setStatus('error');
    }
  }, [consentType]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const grant = useCallback(async () => {
    await consentAPI.setConsent({ consent_type: consentType, version: currentVersion, granted: true });
    setStatus('granted');
  }, [consentType, currentVersion]);

  return { status, currentVersion, ageGroup, grant, refresh };
}
